import '../src/styles/imports.scss'
import '../src/styles/variables.scss'
import '../src/styles/global.bootstrap.scss'
import '../src/styles/global.syncfusion.scss'

import PageLayout from './global/PageLayout.tsx'
import OidcProviderWrapper from './global/OidcProviderWrapper.tsx'
import { loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base'

import * as n1 from '../node_modules/cldr-data/main/de/currencies.json'
import * as n2 from '../node_modules/cldr-data/main/de/timeZoneNames.json'
import * as n3 from '../node_modules/cldr-data/main/de/numbers.json'
import * as n4 from '../node_modules/cldr-data/main/de/ca-gregorian.json'
import * as s from '../node_modules/cldr-data/supplemental/currencyData.json'
import * as s2 from '../node_modules/cldr-data/supplemental/numberingSystems.json'
import { loadLocalization } from './translations/sf-translations.tsx'

setCurrencyCode('EUR')
loadCldr(n1, n2, n3, n4, s, s2)
setCulture('de')
loadLocalization()


const App = () => {
  return (
    <OidcProviderWrapper>
      <PageLayout />
    </OidcProviderWrapper>
  )
}

export default App
